import { render, staticRenderFns } from "./StorageOptionCard.vue?vue&type=template&id=5ef73698"
import script from "./StorageOptionCard.vue?vue&type=script&lang=ts"
export * from "./StorageOptionCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports